import { render } from "./OperatorItem.vue?vue&type=template&id=2b010a8f&scoped=true&ts=true"
import script from "./OperatorItem.vue?vue&type=script&lang=ts"
export * from "./OperatorItem.vue?vue&type=script&lang=ts"

import "./OperatorItem.vue?vue&type=style&index=0&id=2b010a8f&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2b010a8f"]])

export default __exports__